// extracted by mini-css-extract-plugin
module.exports = {"six-story-4s":"styles-m__six-story-4s__1i92T","title":"styles-m__title__3GiNR","story-card":"styles-m__story-card__2HPJQ","story-container":"styles-m__story-container__1zKlf"};